$("body").on("click", ".questioner_answer_master  h2", function () {
  $(this).toggleClass("active");
  $(this).closest(".questioner_answer_master").find(".questions_answers").slideToggle();
});

$("body").on("click", ".questions_answers  h3", function () {
  $(this).toggleClass("active");
  $(this).closest(".questions_answers").find(".answers").slideToggle();
});

if (localStorage.getItem("age-confirm") === null) {
  $("body").addClass("popup-active");
  $("body").find(".age_popup_section").addClass("open-model");
}

$("body").on("click", ".age_1", function () {
  $(".age_confirom").slideToggle();
  $(".age_not_confirom").slideToggle();
  setTimeout(function () {
    window.location.href = "https://www.google.com/";
  }, 3000);
});

$("body").on("click", ".age_2", function () {
  localStorage.setItem("age-confirm", "age-confirm");
  $("body").find(".age_popup_section").removeClass("open-model");
  $("body").removeClass("popup-active");
  $("body").find(".cookie_popup_section").addClass("open-model");
});

$("body").on("click", ".cookie_2", function () {
  $("body").find(".cookie_popup_section").removeClass("open-model");
  $("body").removeClass("popup-active")
});

$("body").on("click", ".slide-nav__button_close", function () {
  $(this).closest(".slide-nav__item").find(".child-nav__dropdown").slideToggle();
  $(this).find(".slide-nav__link").addClass("active");
  $(this).addClass($(this).attr("data-class"));
  $(this).addClass("slide-nav__button_open");
  $(this).removeClass("slide-nav__button_close");
});

$("body").on("click", ".slide-nav__button_open", function () {
  $(this).closest(".slide-nav__item").find(".child-nav__dropdown").slideToggle();
  $(this).find(".slide-nav__link").removeClass("active");
  $(this).removeClass($(this).attr("data-class"));
  $(this).removeClass("slide-nav__button_open");
  $(this).addClass("slide-nav__button_close");
});


$("body").on("click", ".chat_button", function (e) {
  e.preventDefault();
  window.HubSpotConversations.widget.open();
});


$("body").on("change", ".variant_input_check", function () {
  var no_multibuy, leep_qty = false;
  var productTag  = '';
  if($(this).hasClass('no_multibuy')){
    no_multibuy = true;
  }
  $(".variant-purches").hide();
  $(".variant-purches[data-variant='"+$(this).val()+"']").show();
  $(".find_popup_product").attr("data-link", $(".variant-purches[data-variant='"+$(this).val()+"']").attr("data-link"));
  $(".error_message").hide();
  var labelText, qtyText, product_atc, product_qty, productPageInventory, price, qty, ele, productForm;

  productForm = $(".product-form-block");
  $(this).closest(".variant-input-wrap").find(".variant-input").removeClass("active");
  $(this).closest(".variant-input-wrap").find(".variant_input_check").removeClass("selected-variant");
  if ($(this).hasClass("disabled")) {
    $(this).prop('checked', false);
    $(this).closest(".flavor_product_detail").find(".control").addClass("op-0-5");
    $(this).closest(".flavor_product_detail").find(".control").find("input").val(0);
  }
  else {
    $(this).closest(".variant-input").addClass("active");
    $(this).addClass("selected-variant");
    $(this).closest(".flavor_product_detail").find(".control").removeClass("op-0-5");

  }

  $(this).closest(".variant-wrapper").find(".variant__label-info").find("span").text($(labelText).text());

  $(".selected-color").css("background-color", $(labelText).text());

  qtyText = $(this).closest(".grid-item__content").find(".product-inventory");
  product_atc = $(this).closest(".product_grid_product_details").find(".product_atc");
  product_qty = $(this).closest(".product_grid_product_details").find(".form-qty");

  productPageInventory = $(this).closest("div[data-product-blocks]").find(".product-inventory");

  if ($(this).hasClass("disabled")) {
    $(qtyText).removeClass("in-stock");
    $(qtyText).addClass("out-stock");
    $(qtyText).find("span").text("OUT OF STOCK");

    $(productPageInventory).removeClass("in-stock");
    $(productPageInventory).addClass("out-stock");
    $(productPageInventory).find("span").text("OUT OF STOCK");


    $(product_atc).addClass("bg-soldOut wd-100");
    $(product_qty).hide();
    $(product_atc).find("span").text("Sold out");

    $(productForm).find(".product-grid-form").hide();
    $(productForm).find("form").css("width", "100%");
  }
  else {

    $(qtyText).addClass("in-stock");
    $(qtyText).removeClass("out-stock");
    $(qtyText).find("span").text("IN STOCK");

    $(productPageInventory).addClass("in-stock");
    $(productPageInventory).removeClass("out-stock");
    $(productPageInventory).find("span").text("IN STOCK");


    $(product_atc).removeClass("bg-soldOut wd-100");
    $(product_qty).show();
    $(product_atc).find("span").text("Find the nearest store");

    $(productForm).find(".product-grid-form").show();
    $(productForm).find("form").css("width", "auto");
  }

  price = $(this).closest(".variant-input").attr("data-price");
  qty = parseInt($(this).closest(".product_grid_product_details").find(".qty").val());
  if (qty) {
    qty = qty;
  }
  else {
    qty = parseInt($(this).closest("div[data-product-blocks]").find(".qty").val());
  }

  ele = $(this).closest(".product_grid_product_details").closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");
  if (ele.length > 0) {

    ele = ele;
  }
  else {
    ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");
  }

  if (qty > 0) {

    priceDynamic(productTag, price, qty, ele, leep_qty, no_multibuy);
  }
  if ($(this).hasClass("disabled")) {
  }
  else {
    colorSwatchRecommendation(this);
  }

  var variantLength = $(".product-grid__content").find(".variant-input");
  $(".rte.multiple_description").hide();

  for (var i = 0; i < variantLength.length; i++) {
    if ($(variantLength[i]).hasClass("active")) {
      var children = i + 1;
      $(".rte.multiple_description:nth-child(" + children + ")").show();
    }
  }

});

$("body").on("click", ".add-to-cart-grid", function () {
  var productId = $(this).closest(".product_variants_collections").find(".selected-variant").closest(".variant-input").attr("data-id");
  if (productId) {
    productId = productId;
  }
  else {
    productId = $(this).closest(".product_variants_collections").find(".height-67").attr("data-id");
  }
  var qty = $(this).closest(".product-grid-form").find(".input-text").val();
  $(this).find("span").text("Find the nearest store");

  var parentDiv = $(this).closest(".grid-item.grid-product");
  var productPrice = $(parentDiv).find(".grid-product__price--current").find(".visually-hidden").text();
  var variant = $(parentDiv).find(".variant-input.active").attr("data-value");
  var collectionName = $(parentDiv).attr("product-collection-name");
  var productTitle = $(parentDiv).find(".grid-product__title").text();
  var sku = $(".product_variant_picker").find(".variant-input.active").attr("data-sku");
  var optionName = $(parentDiv).find(".variant__label").text();

  addToCart(productId, qty, productTitle, productPrice, variant, collectionName, sku, optionName, grid_button = this);
});

$("body").on("click", ".read_more_less", function () {
  $(this).closest(".collection_description").find("p").toggleClass("open");
  $(this).toggleClass("open");
  if ($(this).find("span").text() == "Show More") {
    $(this).find("span").text("Show Less");
  } else {
    $(this).find("span").text("Show More");
  }
});


$("body").on("click", ".minus-plus", function () {
  var leep_qty, bundle_pro = false;
  var leep_qty, bundle_pro, no_multibuy = false;
  var productTag = $(this).attr("data-tag");
  if($(this).hasClass('leep_qty')){
    leep_qty = true;
  }
  if($(this).hasClass('bundle_qty')){
    bundle_pro = true;
  }
  if($(this).hasClass('no_multibuy')){
    no_multibuy = true;
  }
  $(this).closest(".control").find(".button-minus").removeClass("op-0-5");
  var productQty, ele, price;

  productQty = parseInt($(this).closest(".control").find(".input-text").val());

  if (jQuery.isNumeric(productQty)) {
    if ($(this).hasClass("button-minus")) {
      // productQty = parseInt(productQty - 1);
      if(bundle_pro){
        productQty = parseInt(productQty-2);
      }
      else{
        productQty = parseInt(productQty-1);
      }
      if (productQty < 0 || productQty === 0) {
        $(this).addClass("op-0-5");
        $(this).closest(".control").find(".input-text").val(0);
        $(this).closest(".product-grid-form").find(".product_atc").addClass("disabled-btn");
        $(".add-to-cart-product").addClass("disabled-btn");

        ele = $(this).closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");

        if (ele.length > 0) {

          ele = ele;
        }
        else {

          ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");

        }
        priceDynamic(productTag, 0.00, 0, ele, leep_qty, no_multibuy);

      }
      else {
        $(this).removeClass("op-0-5");
        $(".add-to-cart-product").removeClass("disabled-btn");
        $(this).closest(".product-grid-form").find(".product_atc").removeClass("disabled-btn");
        $(this).closest(".control").find(".input-text").val(productQty);

        productQty = parseInt($(this).closest(".control").find(".input-text").val());
        ele = $(this).closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");

        if (ele.length > 0) {

          ele = ele;
        }
        else {

          ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");

        }

        price = parseFloat($(this).closest(".product_grid_product_details").find(".variant-input.active").attr("data-price"));


        if (price) {
          price = price;
        }
        else {
          price = parseFloat($(this).closest(".control").attr("data-price"));
        }
        priceDynamic(productTag, price, productQty, ele, leep_qty, no_multibuy);
      }

    }
    else {
      $(".add-to-cart").removeClass("disabled-btn");
      $(this).closest(".product-grid-form").find(".product_atc").removeClass("disabled-btn");
      if(productQty < 10){
        if(bundle_pro){
          productQty = parseInt(productQty+2);
        }
        else{
          productQty = parseInt(productQty+1);
        }
        $(this).closest(".control").find(".input-text").val(productQty);
      }
      productQty = parseInt($(this).closest(".control").find(".input-text").val());
      ele = $(this).closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");

      if (ele.length > 0) {
        ele = ele;
      }
      else {
        ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");
      }
        price = parseFloat($(this).closest(".product_grid_product_details").find(".variant-input.active").attr("data-price"));
      if (price) {
        price = price;
      }
      else {
        price = parseFloat($(this).closest(".control").attr("data-price"));
      }
      priceDynamic(productTag, price, productQty, ele, leep_qty, no_multibuy);
    }
  }

});


$("body").on("change", ".input-text", function () {
  var productQty, ele, price;
  var leep_qty, no_multibuy = false;
  var productTag = $(this).attr("product-tag")
  if($(this).hasClass('leep_qty')){
    leep_qty = true;
  }
  if($(this).hasClass('no_multibuy')){
    no_multibuy = true;
  }

  if ($(this).val()) {
    productQty = parseInt($(this).val());
    if (productQty < 0) {
      $(this).val(0);
      productQty = 0;
    }
    ele = $(this).closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");

    if (ele.length > 0) {

      ele = ele;
    }
    else {
      ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");
    }

    price = parseFloat($(this).closest(".product_grid_product_details").find(".variant-input.active").attr("data-price"));

    if (price) {
      price = price;
    }
    else {
      price = parseFloat($(this).closest(".control").attr("data-price"));
    }

    if (productQty === 0) {

      $(this).closest(".product-grid-form").find(".product_atc").addClass("disabled-btn");
    }
    else {

      $(this).closest(".product-grid-form").find(".product_atc").removeClass("disabled-btn");
    }
    priceDynamic(productTag, price, productQty, ele, leep_qty, no_multibuy);
  }
});
var dataCount = '';


function addToCart(productId, qty, productTitle, price, variant, collection, sku, optionName, grid_button) {
  // dataLayer.push({
  //   'event': 'add_to_cart',
  //   'ecommerce': {
  //     'items': [{
  //       'item_name': productTitle, // Name or ID is required. 
  //       'item_id': productId,
  //       'price': price,
  //       'item_brand': 'VELO PK',
  //       'item_category': collection,
  //       'item_category_2': '',
  //       'item_category_3': '',
  //       'item_category_4': '',
  //       'item_variant': variant,
  //       'item_list_name': '',
  //       'item_list_id': '',
  //       'index': 1,
  //       'quantity': qty
  //     }]
  //   }
  // });
  // dataLayer.push({
  //   'event': 'addToCart',
  //   'ecommerce':
  //   {
  //     'currencyCode': 'PKR',
  //     'add': {
  //       'products': [{
  //         'name': productTitle,
  //         'id': sku,
  //         'price': price,
  //         'brand': 'VELO PK',
  //         'strength': variant,
  //         'quantity': qty,
  //         'format': optionName,
  //         'dimension': variant,
  //       }
  //       ]
  //     }
  //   }
  // });
  if (localStorage.getItem('free_can_note')) {
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      data: '',
      success: function (data) {
        localStorage.removeItem('free_can_note')
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: {
            id: productId,
            quantity: qty,
          },
          success: function (data) {
            openCart();
          },
          error: function (data) {
            $(grid_button).closest(".product_grid_product_details").find(".error_message").fadeIn();
            $(grid_button).closest(".product_grid_product_details").find(".error_message").text(data.responseJSON.description);
            $(grid_button).find("span").text("Find the nearest store");
            setTimeout(function () {
              $(grid_button).closest(".product_grid_product_details").find(".error_message").fadeOut();
            }, 4000);
          }
        });
      },
      error: function (data) {
  
      }
    });
  }
  else{
    cartQuantity(function(count){
      dataCount = count;
      var totalQty = dataCount+parseInt(qty);
      if(totalQty <= 10){
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: {
            id: productId,
            quantity: qty,
          },
          success: function (data) {
            openCart();
          },
          error: function (data) {
            $(grid_button).closest(".product_grid_product_details").find(".error_message").fadeIn();
            $(grid_button).closest(".product_grid_product_details").find(".error_message").text(data.responseJSON.description);
            $(grid_button).find("span").text("Find the nearest store");
            setTimeout(function () {
              $(grid_button).closest(".product_grid_product_details").find(".error_message").fadeOut();
            }, 4000);
          }
        });
      }
      else{
        CartFullPoup();
      }
    });
  }
}

$(document).ready(function () {
  var labelText = $(".variant-input.active").find("label");
  if ($(labelText).text().indexOf("Azee") >= 0 || $(labelText).text().indexOf("Deyaa") >= 0) {
    $(".page-content.page-content--product").addClass("black-content");
    $(".product_meta_title.special_addition").show();
    $(".product_meta_title.normal_product").hide();
    $("#special_addition").show();
  }
  else {
    $(".page-content.page-content--product").removeClass("black-content");
    $(".product_meta_title.special_addition").hide();
    $(".product_meta_title.normal_product").show();
    $("#special_addition").hide();
  }

  setInterval(function () {
    var activeState = $(".product-grid__content").find(".variant-input.active").find("label");
    if ($(activeState).text().includes("Deyaa") || $(activeState).text().includes("Azee")) {

      $(".color_name").text($(activeState).text().toUpperCase() + ' limited edition');
    }
    else {
      $(".color_name").text($(activeState).text());
    }
    if ($(activeState).attr("data-variant-color-image")) {
      var imgUrl = $(activeState).attr("data-variant-color-image");
      $(".selected-color").css("background-image", "url(" + imgUrl + ")");
      $(".selected-color").css("background-color", "");
    }
    else {
      $(".selected-color").css("background-image", "url('')");
      $(".selected-color").css("background-color", $(activeState).attr('data-color-fallBack'));
    }
  }, 800);

  // $(".site-nav__link_account").hover(function(){
  //   $(".overlay").addClass("overlay-open");
  //   $(".account_child_links").addClass("open-account");
  //   }, function(){
  //     if($(".account_child_links").hasClass("open-account")){

  //     }
  //     else{
  //       $(".overlay").removeClass("overlay-open");
  //       $(".account_child_links").removeClass("open-account");
  //     }
  // });
});

function priceDynamic(productTag, price, qty, ele, leep_qty, no_multibuy) {
  if(leep_qty || no_multibuy){
    $(ele).text("AED " + (price * qty).toFixed(2));
  }
  else{
    if(qty === 1 || qty < 4){
      $(ele).text("AED " + (price * qty).toFixed(2));
    }
    else{
      if(qty > 3 && qty < 7 ){
        var newPrice = price*qty;
        var newQty = qty*5;
        $(ele).text("AED " + (newPrice-newQty).toFixed(2));
        // $(ele).append("<span class='instaed_text_price'>instead of</span><span class='instaed_price'>Rs."+(price * qty).toFixed(2)+"</span>");
      }
      else{
        if(qty > 6 && qty < 10){
          var newPrice = price*qty;
          var newQty = qty*10;
          $(ele).text("AED " + (newPrice-newQty).toFixed(2));
          // $(ele).text("Rs. " + (price * qty).toFixed(2));
          // $(ele).append("<span class='instaed_text_price'>instead of</span><span class='instaed_price'>Rs."+(price * qty).toFixed(2)+"</span>");
        }
        else{
          if(qty > 9 && qty < 11){
            var newPrice = price*qty;
            if(productTag == '_14'){
              var newQty = qty*16;
            }
            if(productTag == '_10'){
              var newQty = qty*14;
            }
            if(productTag == '_6'){
              var newQty = qty*12;
            }
            $(ele).text("AED " + (newPrice-newQty).toFixed(2));
            // $(ele).append("<span class='instaed_text_price'>instead of</span><span class='instaed_price'>Rs."+(price * qty).toFixed(2)+"</span>");
          }
        }
      }
    }
  }
}


function colorSwatchRecommendation(e) {

  colorImages = $(e).closest(".variant-input").find("label[data-variant-id]");

  if (colorImages.length) {
    setActiveColorImage(colorImages);
  }
}

function setActiveColorImage(swatch) {
  var id = $(swatch).attr("data-variant-id");
  var image = $(swatch).attr("data-variant-image");
  if (image) {

    $(".grid-product__color-image").removeClass("is-active");
    // Set active image and swatch
    var imageEl = $(swatch).closest(".grid-item__content").find('.grid-product__color-image--' + id);
    $(imageEl).css("background-image", "url(" + image + ")");
    //   imageEl.style.backgroundImage = 'url(' + image + ')';
    $(imageEl).addClass('is-active');

  }
  // Update product grid item href with variant URL
  var variantUrl = $(swatch).attr("data-url");
  var gridItem = $(swatch).closest(".grid-item__content").find('.grid-item__link');

  $(gridItem).attr('href', variantUrl);
}



$("body").on("click", ".add-to-cart-flavor", function () {
  var totalVal = 0;
  var itemsData = [];
  var inputs = $('.flavors_qty').find(".input-text");
  for (var i = 0; i < inputs.length; i++) {
    totalVal = parseInt($(inputs[i]).val()) + parseInt(totalVal);
    var productId = $(inputs[i]).closest(".flavor_product_detail").find(".flavors_variants").find(".variant-input.active").attr("data-id");
    if (productId) {
      itemsData.push({
        id: productId,
        quantity: parseInt($(inputs[i]).val()),
        properties: {
          "_customBundle": '_customBundle'
        }
      });
    }
  }
  if (totalVal > 0) {
    if (totalVal % 5 === 0) {

      $(".bundle_error_master").hide();
      $(this).find("span").text("Adding...");
      bundleATC(itemsData);
    }
    else {
      var nextBundle = round(totalVal);
      var nextBundleRemaing = round(totalVal) - totalVal;
      var nextBundleCount = nextBundle / 5;

      $(".bundle_error_master").find("p").text("Select " + nextBundleRemaing + " additional flavors to complete your " + nextBundleCount);
      if (nextBundleCount === 1) {

        $(".bundle_error_master").find("p").append("<span>st</span> bundle");
      }
      else if (nextBundleCount === 2) {

        $(".bundle_error_master").find("p").append("<span>nd</span> bundle");
      }
      else if (nextBundleCount === 3) {

        $(".bundle_error_master").find("p").append("<span>rd</span> bundle");
      }
      else {

        $(".bundle_error_master").find("p").append("<span>th</span> bundle");
      }
      $(".bundle_error_master").show();
    }
  }
});

function round(x) {
  return Math.ceil(x / 5) * 5;
}

function bundleATC(items) {
  var data = {
    items
  };

  //   return;
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: data,
    success: function (data) {
      openCart();
    }
  });

}

$(window).on('load resize orientationchange', function () {
  $('.index-collcetion-content .collection_grid_master').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
        $carousel.slick({
          dots: true,
          arrows: true,
          speed: 300,
          slidesToShow: 4,
          slideToScroll:1,
          infinite: false,
          prevArrow:'<span class="slick_index slick_left"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 17.1359L4.27912 9.95572L11.25 2.77295L9.48544 0.955078L0.75 9.95572L9.48544 18.9551L11.25 17.1359Z" fill="#2B2B2B"/></svg></span>',
          nextArrow:'<span class="slick_index slick_right"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.75 2.77423L7.72088 9.95444L0.75 17.1372L2.51456 18.9551L11.25 9.95444L2.51456 0.955077L0.75 2.77423Z" fill="#2B2B2B"/></svg></span>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slideToScroll:1,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slideToScroll:1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slideToScroll:1,
              }
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 2,
                slideToScroll:1,
              }
            }
          ]
        });
  });

  $('.product-recommendations-placeholder .new-grid').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
        $carousel.slick({
          dots: true,
          arrows: true,
          speed: 300,
          slidesToShow: 4,
          slideToScroll:1,
          infinite: false,
          prevArrow:'<span class="slick_index slick_left"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 17.1359L4.27912 9.95572L11.25 2.77295L9.48544 0.955078L0.75 9.95572L9.48544 18.9551L11.25 17.1359Z" fill="#2B2B2B"/></svg></span>',
          nextArrow:'<span class="slick_index slick_right"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.75 2.77423L7.72088 9.95444L0.75 17.1372L2.51456 18.9551L11.25 9.95444L2.51456 0.955077L0.75 2.77423Z" fill="#2B2B2B"/></svg></span>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slideToScroll:1,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slideToScroll:1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slideToScroll:1,
              }
            }
          ]
        });
  });

  $('.about_section_right_inner').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    $carousel.slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slideToScroll:1,
      infinite: false,
      animation:'ease',
      prevArrow:'<span class="slick_index slick_left"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.8486 53.2301L4.29464 29.992L3.43199 29.4592C1.64999 28.3585 1.6002 25.7847 3.33832 24.6159L36.4042 2.38199C38.7977 0.772562 41.9967 3.3728 41.1273 6.12292C36.2163 21.6567 36.6151 35.8587 40.7875 49.4971C41.6531 52.3265 38.2311 54.9847 35.8486 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
      nextArrow:'<span class="slick_index slick_right"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.40921 53.2301L38.9632 29.992L39.8258 29.4592C41.6078 28.3585 41.6576 25.7847 39.9195 24.6159L6.85364 2.38199C4.46014 0.772562 1.26107 3.3728 2.13051 6.12292C7.04148 21.6567 6.64275 35.8587 2.47035 49.4971C1.60476 52.3265 5.02674 54.9847 7.40921 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
    });
  });
  $('.images_slider_5').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    $carousel.slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slideToScroll:1,
      infinite: true,
      animation:'ease',
      prevArrow:'<span class="slick_index slick_left"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.8486 53.2301L4.29464 29.992L3.43199 29.4592C1.64999 28.3585 1.6002 25.7847 3.33832 24.6159L36.4042 2.38199C38.7977 0.772562 41.9967 3.3728 41.1273 6.12292C36.2163 21.6567 36.6151 35.8587 40.7875 49.4971C41.6531 52.3265 38.2311 54.9847 35.8486 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
      nextArrow:'<span class="slick_index slick_right"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.40921 53.2301L38.9632 29.992L39.8258 29.4592C41.6078 28.3585 41.6576 25.7847 39.9195 24.6159L6.85364 2.38199C4.46014 0.772562 1.26107 3.3728 2.13051 6.12292C7.04148 21.6567 6.64275 35.8587 2.47035 49.4971C1.60476 52.3265 5.02674 54.9847 7.40921 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
    });
  });
  $('.images_slider_4').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    $carousel.slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slideToScroll:1,
      infinite: true,
      animation:'ease',
      prevArrow:'<span class="slick_index slick_left"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.8486 53.2301L4.29464 29.992L3.43199 29.4592C1.64999 28.3585 1.6002 25.7847 3.33832 24.6159L36.4042 2.38199C38.7977 0.772562 41.9967 3.3728 41.1273 6.12292C36.2163 21.6567 36.6151 35.8587 40.7875 49.4971C41.6531 52.3265 38.2311 54.9847 35.8486 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
      nextArrow:'<span class="slick_index slick_right"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.40921 53.2301L38.9632 29.992L39.8258 29.4592C41.6078 28.3585 41.6576 25.7847 39.9195 24.6159L6.85364 2.38199C4.46014 0.772562 1.26107 3.3728 2.13051 6.12292C7.04148 21.6567 6.64275 35.8587 2.47035 49.4971C1.60476 52.3265 5.02674 54.9847 7.40921 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
    });
  });
  $('.images_slider_3').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    $carousel.slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slideToScroll:1,
      infinite: true,
      animation:'ease',
      prevArrow:'<span class="slick_index slick_left"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.8486 53.2301L4.29464 29.992L3.43199 29.4592C1.64999 28.3585 1.6002 25.7847 3.33832 24.6159L36.4042 2.38199C38.7977 0.772562 41.9967 3.3728 41.1273 6.12292C36.2163 21.6567 36.6151 35.8587 40.7875 49.4971C41.6531 52.3265 38.2311 54.9847 35.8486 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
      nextArrow:'<span class="slick_index slick_right"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.40921 53.2301L38.9632 29.992L39.8258 29.4592C41.6078 28.3585 41.6576 25.7847 39.9195 24.6159L6.85364 2.38199C4.46014 0.772562 1.26107 3.3728 2.13051 6.12292C7.04148 21.6567 6.64275 35.8587 2.47035 49.4971C1.60476 52.3265 5.02674 54.9847 7.40921 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
    });
  });
  $('.images_slider_2').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    $carousel.slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slideToScroll:1,
      infinite: true,
      animation:'ease',
      prevArrow:'<span class="slick_index slick_left"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.8486 53.2301L4.29464 29.992L3.43199 29.4592C1.64999 28.3585 1.6002 25.7847 3.33832 24.6159L36.4042 2.38199C38.7977 0.772562 41.9967 3.3728 41.1273 6.12292C36.2163 21.6567 36.6151 35.8587 40.7875 49.4971C41.6531 52.3265 38.2311 54.9847 35.8486 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
      nextArrow:'<span class="slick_index slick_right"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.40921 53.2301L38.9632 29.992L39.8258 29.4592C41.6078 28.3585 41.6576 25.7847 39.9195 24.6159L6.85364 2.38199C4.46014 0.772562 1.26107 3.3728 2.13051 6.12292C7.04148 21.6567 6.64275 35.8587 2.47035 49.4971C1.60476 52.3265 5.02674 54.9847 7.40921 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
    });
  });
  $('.images_slider_1').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    $carousel.slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slideToScroll:1,
      infinite: true,
      animation:'ease',
      prevArrow:'<span class="slick_index slick_left"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.8486 53.2301L4.29464 29.992L3.43199 29.4592C1.64999 28.3585 1.6002 25.7847 3.33832 24.6159L36.4042 2.38199C38.7977 0.772562 41.9967 3.3728 41.1273 6.12292C36.2163 21.6567 36.6151 35.8587 40.7875 49.4971C41.6531 52.3265 38.2311 54.9847 35.8486 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
      nextArrow:'<span class="slick_index slick_right"><svg width="43" height="56" viewBox="0 0 43 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.40921 53.2301L38.9632 29.992L39.8258 29.4592C41.6078 28.3585 41.6576 25.7847 39.9195 24.6159L6.85364 2.38199C4.46014 0.772562 1.26107 3.3728 2.13051 6.12292C7.04148 21.6567 6.64275 35.8587 2.47035 49.4971C1.60476 52.3265 5.02674 54.9847 7.40921 53.2301Z" stroke="white" stroke-width="2.88177"/></svg></span>',
    });
  });
  $('.about_velo_section_8_slider').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    $carousel.slick({
      dots: false,
      arrows: false,
      speed: 1000,
      slidesToShow: 4,
      slideToScroll:1,
      infinite: true,
      animation:'ease',
      centerMode: true,
      centerPadding: '40px',
      autoplay: true,
      cssEase: 'linear',
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slideToScroll:1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slideToScroll:1,
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
            slideToScroll:1,
          }
        }
      ]
    });
  });

  $('.slider_inner_mobile').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 768) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else {
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          dots: false,
          arrows: false,
          speed: 300,
          slidesToShow: 1,
          slideToScroll:1,
          centerMode: false,
          centerPadding: '30px',
          infinite: true
        });
      }
    }
  });

  $('.section_7_slide').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 768) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else {
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          dots: true,
          arrows: false,
          speed: 300,
          slidesToShow: 2,
          centerMode: false,
          centerPadding: '30px',
        });
      }
    }
  });
});
// $(".slider_inner").slick({
//   dots: false,
//   arrows: false,
//   speed: 300,
//   slidesToShow: 3,
//   slideToScroll:1,
//   centerMode: false,
//   centerPadding: '30px',
//   infinite: true
// });

$("body").on("click", ".checkout_discount_button", function (e) {
  e.preventDefault();
  var disccount = $("input[name='dicount']").val();

  window.location.href = '/checkout?discount=' + disccount;
});

// $("body").on("click", ".cart__continue", function (e) {
//   e.preventDefault();
//   window.location.href = document.referrer;
// });

$("body").on("click", ".eye-close-open", function (e) {
  $(this).closest(".password_field").find(".eye-open").toggleClass("hide");
  $(this).closest(".password_field").find(".eye-close").toggleClass("hide");
  if ($(this).closest(".password_field").find(".input-full").attr("type") === 'password') {
    $(this).closest(".password_field").find(".input-full").attr("type", "text");
  }
  else {
    $(this).closest(".password_field").find(".input-full").attr("type", "password");
  }
});

$("body").on("click", ".address-edit", function () {
  var id = $(this).attr("data-form-id");
  var defaultCityVal = $("#EditAddress_"+id).find(".default-address-city").data("title");
  console.log(defaultCityVal);
  $("#AddressCity_"+id).val(defaultCityVal);
  $("#EditAddress_" + id).toggleClass("hide");
});

$("body").on("click", ".add-to-cart_custom", function (e) {
  e.preventDefault();
  var qty = $(this).closest("div[data-product-blocks]").find(".js-qty__num").val();
  var productId = $(".product_variant_picker").find(".variant-input.active").attr("data-id");
  
  if((typeof productId === "undefined")){
    productId = $(".product-single__variants").val();
  }
  var sku = $(".product_variant_picker").find(".variant-input.active").attr("data-sku");
  $(this).find("span[data-default-text]").text("Adding...");
  var parentDiv = $(this).closest(".product-grid__content");
  var productPrice = $(parentDiv).find(".product__price").find(".visually-hidden").text();
  var variant = $(parentDiv).find(".variant-input.active").attr("data-value");
  
  var collectionName = $(parentDiv).closest(".product-section").attr("data-collection");
  var productTitle = $(parentDiv).closest(".product-section").attr('data-product-title');
  var optionName = $(parentDiv).find(".variant__label").text();
  
  addToCart(productId, qty, productTitle, productPrice, variant, collectionName, sku, optionName);
});

$("body").on("click", ".custom_js-qty__adjust", function () {
  var inputVal = parseInt($(this).closest(".cart_update_button_master").find("input").val());
  var productId = $(this).closest(".cart_update_button_master").find("input").attr("data-id");
  var parentDiv = $(this).closest(".cart__item");
  var productTitle = $(parentDiv).attr("data-title");
  var price = $(parentDiv).attr("data-price");
  var collection = $(parentDiv).attr("data-collection");
  var variant = $(parentDiv).find(".drawer_variant").text();
  var sku = $(parentDiv).attr("data-sku");
  if ($(this).hasClass("js-qty__adjust--minus")) {
    inputVal = parseInt(inputVal - 1);

    if (inputVal < 0) {
      inputVal = 0;
      // dataLayer.push({
      //   'event': 'removeFromCart',
      //   'ecommerce': {
      //     'remove': {
      //       'products': [
      //         {
      //           'name': productTitle,
      //           'id': sku,
      //           'price': price,
      //           'brand': 'VELO Pk',
      //           'strength': variant,
      //           'quantity': inputVal,
      //           'format': 'Can',
      //           'dimension': variant,
      //         }
      //       ]
      //     }
      //   }
      // });
    }
    else {
      inputVal = inputVal;
      // dataLayer.push({
      //   'event': 'removeFromCart',
      //   'ecommerce': {
      //     'remove': {
      //       'products': [
      //         {
      //           'name': productTitle,
      //           'id': sku,
      //           'price': price,
      //           'brand': 'VELO Pk',
      //           'strength': variant,
      //           'quantity': inputVal,
      //           'format': 'Can',
      //           'dimension': variant,
      //         }
      //       ]
      //     }
      //   }
      // });
    }
  }
  else {
    inputVal = inputVal + 1;
  }
  $(this).closest(".cart_update_button_master").find("input").val(inputVal);
  if (inputVal == '0') {
    // dataLayer.push({
    //   'event': 'add_to_cart',
    //   'ecommerce': {
    //     'items': [{
    //       'item_name': productTitle, // Name or ID is required. 
    //       'item_id': productId,
    //       'price': price,
    //       'item_brand': 'VELO PK',
    //       'item_category': collection,
    //       'item_category_2': '',
    //       'item_category_3': '',
    //       'item_category_4': '',
    //       'item_variant': variant,
    //       'item_list_name': '',
    //       'item_list_id': '',
    //       'index': 1,
    //       'quantity': inputVal
    //     }]
    //   }
    // });
  }
  updateCart(productId, inputVal);
});

function updateCart(productId, qty) {
  var cartNumber = parseInt($(".cart-link__bubble-num").text());
  var totalQty = cartNumber+1;
  console.log(totalQty);
  if(totalQty <= 10){
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { quantity: qty, id: productId },
      dataType: 'json',
      success: function (cart) {
        openCart();
      }
    });
  }
  else{
    // $(".add-to-cart_custom").text("Find the nearest store")
    CartFullPoup();
  }
}

function openCart() {
  $.ajax({
    type: 'GET',
    url: '/cart?view=drawer',
    async: false,
    success: function (cart) {
      $(".drawer__cart").html('');
      $(".drawer__cart").html(cart);
      $(".overlay").addClass("overlay-open");
      $("body").addClass("drawer-open");
      $("#myModal").addClass("view-model");
      var cartCount = parseInt($("#myModal").find(".cart_count").attr("data-id"));
      var cartPrice = $("#myModal").find(".total_price").find("span[aria-hidden='true']").text();
      if (cartCount > 0) {
        $(".cart-link__bubble").addClass("cart-link__bubble--visible");
        $("#HeaderCartTrigger").find(".site-nav__icon-label.small--hide").text(cartPrice);
      }
      else {
        $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
        $("#HeaderCartTrigger").find(".site-nav__icon-label.small--hide").text("AED 0.00");
      }
      $(".cart-link__bubble-num").text(cartCount);
      $(".add-to-cart").find("span[data-default-text]").text("Find the nearest store");
      $(".add-to-cart-grid").find("span").text("Find the nearest store");
      $(".add-to-cart-flavor").find("span").text("Find the nearest store");
    }
  });
}
var container = $(".modal-content");
$(document).click(function () {
  if (!container.is(event.target) && !container.has(event.target).length) {
    $("#myModal").removeClass("view-model");
    $(".overlay").removeClass("overlay-open");
    $("body").removeClass("drawer-open");
  }
});

$(document).on('keydown', function (e) {
  if (e.keyCode === 27) { // ESC
    $("#myModal").removeClass("view-model");
    $(".overlay").removeClass("overlay-open");
    $("body").removeClass("drawer-open");
  }
});

$("body").on("click", ".close_model, .basket_button", function () {
  $("#myModal").removeClass("view-model");
  $(".overlay").removeClass("overlay-open");
  $("body").removeClass("drawer-open");
});

$('body').on("click", ".recyle_epod_input", function () {
  var selected_value = $("input[name='recyle_epod']:checked").val();

  if (selected_value === 'Yes') {
    $(".cart_note").val("Recycle");
  }
  else {
    $(".cart_note").val("");
  }
});

window.onload = setTimeout(function () {
  $(".grid__item").removeClass("op-0");
  $("#season_view_all").attr("href", $(".season_artis_list.show").attr("data-link"));
}, 2000);

var addressId = '';
$("body").on("click", ".address_delete_custom", function () {
  addressId = $(this).attr("data-id");
  $(".overlay").addClass("overlay-opens");
  $("body").addClass("drawer-opens");
  $(".address_remove_popup").addClass("view-address-model");
});

$("body").on("click", ".address_remove_btn_1", function () {
  Shopify.postLink('/account/addresses/' + addressId, { parameters: { _method: 'delete' } });
});
$("body").on("click", ".address_remove_btn_2, .close_address", function () {
  $(".overlay").removeClass("overlay-opens");
  $("body").removeClass("drawer-opens");
  $(".address_remove_popup").removeClass("view-address-model");
});

$("body").on("click", ".close_password", function () {
  $(".overlay").removeClass("overlay-opens-password");
  $("body").removeClass("drawer-opens-password");
  $(".reset_password_success").removeClass("view-address-model");
  $(".clear_cart_popup").removeClass("view-address-model");
  $(".qty_cart_popup").removeClass("view-address-model view-cart-model");
});
$("body").on("click", ".close_login_form", function () {
  $(".overlay").removeClass("overlay-opens-password");
  $("body").removeClass("drawer-opens-password");
  $(".social_login_master_form").removeClass("view-address-model");
  $("#google_login").find("span").text("sign in with google");
  $("#facebook_login").find("span").text("sign in with facebook");
  $(".facebook_login_btn").addClass("pointer-none");
  $(".google_login_btn").addClass("pointer-none");
  // dataLayer.push({
  //   'event': 'login_failure', 
  //      'eventAction':'failure',
  //      'eventLabel':'invalid credentilas', 
  //      'eventCategory': 'login'
  // });
});
var msg = $(".errors").find("li").text();
var index = msg.indexOf('This email address is already associated with an account. If this account is yours, you can reset your password');
if (index !== -1) {
  localStorage.removeItem('just_registered');
  dataLayer.push({
    'event': 'registration_failed',
    'eventAction': 'registration Failure', 
    'eventLabel': 'fail', 
    'errorType': 'email_duplicate',
    'errorFields':'This email address is already associated with an account. If this account is yours, you can reset your password'
 });
}
// var msg = $(".errors").find("li").text();
var index = msg.indexOf("please click the link included to verify your email address");
if (index !== -1) {
  $(".errors").addClass("email_successfull");
  dataLayer.push({
    'event': 'registration',
    'eventAction': 'registration Success', 
    'eventLabel': 'success'
  });
  // dataLayer.push({
  //   'event': 'registration',
  //   'eventAction': 'registration Success',
  //   'eventLabel': 'success'
  // });
}
// var msg = $(".errors").find("li").text();
var lognFailed = msg.indexOf('Incorrect email or password.');
if(lognFailed !== -1){
  dataLayer.push({ 
    'event': 'account',
    'eventAction': 'login',
    'eventLabel': 'fail',
    'errorType': 'incorrect_credentials',
    'errorFields': 'Incorrect email or password.'
  });
}

$("body").on("click", ".grid-item__link", function (e) {
  e.preventDefault();
  var redirectLink = $(this).attr("href");
  var parentDiv = $(this).closest(".grid-item.grid-product");
  var productId = $(parentDiv).attr("data-product-id");
  var productTitle = $(this).find(".grid-product__title").text();
  var selectedVar = $(parentDiv).find(".variant-input.active").attr("data-value");
  var productPrice = $(parentDiv).find(".grid-product__price--current").find("span[aria-hidden='true']").text();
  var productQty = $(parentDiv).find(".variant-input.active").attr("data-variant-qty");
  var productCollection = $(parentDiv).attr("product-collection-name");
  var productType = $(parentDiv).attr("product-type");
  var productSKU = $(parentDiv).find(".variant-input.active").attr("data-sku");
  var optionName = $(parentDiv).find(".variant__label").text();
  // dataLayer.push({
  //   'event': 'select_item',
  //   'ecommerce': {
  //     'items': [{
  //       'item_name': productTitle, // Name or ID is required. 
  //       'item_id': productId,
  //       'item_brand': 'VELO Pk',
  //       'item_category': productCollection,
  //       'item_category_2': '',
  //       'item_category_3': '',
  //       'item_category_4': '',
  //       'item_variant': selectedVar,
  //       'item_list_name': productType,
  //       'item_list_id': '',
  //       'index': 2,
  //       'quantity': productQty,
  //       'price': productPrice
  //     }]
  //   }
  // });

  // dataLayer.push({

  //   'event': 'productClick',
  //   'ecommerce': {
  //     'click': {
  //       'actionField': {
  //         'list': ''
  //       }, // Optional list property to match list:<value> of the productImpression. 
  //       'products': [
  //         {
  //           'name': productTitle,
  //           'id': productSKU,
  //           'price': productPrice,
  //           'brand': 'VELO Pk',
  //           'strength': selectedVar,
  //           'format': optionName,
  //           'dimension': selectedVar,
  //         }]
  //     }
  //   },
  //   'eventCallback': function () {
  //     document.location = redirectLink
  //   }
  // });
  window.location.href = redirectLink;
});


$("body").on("click", ".cart__checkout", function () {

  var singleItem = {};
  var itemsArray = [];
  var singleItem_2 = {};
  var itemsArray_2 = [];
  if ($(this).closest(".cart__page_drawer").length > 0) {

    $(".cart__page_drawer").find('.cart__item').each(function (i, obj) {

      singleItem.item_name = $(this).attr("data-title");
      singleItem.price = $(this).attr("data-price");
      singleItem.item_category = $(this).attr("data-collection");
      singleItem.item_category_2 = '';
      singleItem.item_category_3 = '';
      singleItem.item_category_4 = '';
      singleItem.item_variant = $(this).find(".drawer_variant").text();
      singleItem.item_brand = 'VELO PK';
      singleItem.item_id = $(this).attr("data-id");
      singleItem.quantity = $(this).attr("data-qty");
      singleItem.item_list_name = '';
      singleItem.item_list_id = '';
      singleItem.index = '';

      itemsArray.push({ ...singleItem });

      singleItem_2.name = $(this).attr("data-title");
      singleItem_2.id =  $(this).attr("data-sku"); 
      singleItem_2.price = $(this).attr("data-price"); 
      singleItem_2.brand = 'VELO PK';
      singleItem_2.category = $(this).find(".drawer_variant_label").text();
      singleItem_2.strength =  $(this).find(".drawer_variant").text();
      singleItem_2.quantity = $(this).attr("data-qty");
      singleItem_2.format =  $(this).find(".drawer_variant_label").text();
      singleItem_2.dimension= $(this).find(".drawer_variant").text();
      itemsArray_2.push({ ...singleItem_2 });
    });
  }
  else {
    if ($(this).closest(".cart_page_master").length > 0) {
      $(".cart_page_master").find('.cart__item').each(function (i, obj) {
        singleItem.item_name = $(this).attr("data-title");
        singleItem.price = $(this).attr("data-price");
        singleItem.item_category = $(this).attr("data-collection");
        singleItem.item_category_2 = '';
        singleItem.item_category_3 = '';
        singleItem.item_category_4 = '';
        singleItem.item_variant = $(this).find(".drawer_variant").text();
        singleItem.item_brand = 'VELO Pk';
        singleItem.item_id = $(this).attr("data-id");
        singleItem.quantity = $(this).attr("data-qty");
        singleItem.item_list_name = '';
        singleItem.item_list_id = '';
        singleItem.index = '';
        itemsArray.push({ ...singleItem });

        singleItem_2.name = $(this).attr("data-title");
        singleItem_2.id =  $(this).attr("data-sku"); 
        singleItem_2.price = $(this).attr("data-price"); 
        singleItem_2.brand = 'VELO PK';
        singleItem_2.category = $(this).find(".drawer_variant_label").text();
        singleItem_2.strength =  $(this).find(".drawer_variant").text();
        singleItem_2.quantity = $(this).attr("data-qty");
        singleItem_2.format =  $(this).find(".drawer_variant_label").text();
        singleItem_2.dimension= $(this).find(".drawer_variant").text();
        itemsArray_2.push({ ...singleItem_2 });
      });
    }
  }
  console.log(itemsArray);
  onCheckout(itemsArray, itemsArray_2);
});

function onCheckout(itemslist, itemslist_2) {
  // dataLayer.push({
  //   'event': 'begin_checkout',
  //   'ecommerce': {
  //     'items': itemslist
  //   }
  // });
  // dataLayer.push({
  //   'event': 'checkout',
  //   'ecommerce': {
  //     'currencyCode': 'Rs.',
  //     'checkout': {
  //       'actionField': { 'step': 1 },
  //       'products': itemslist_2
  //     }
  //   },
  //   'eventCallback': function () {
  //     //document.location = '/checkout';
  //   }
  // });
}
$("body").on("click", ".signout", function () {
  dataLayer.push({
    'event': 'account',
    'eventAction': 'logout',
    'eventLabel': 'success'
  });
  localStorage.removeItem('lastLoginCustomerId');
});

$("body").on("click", ".no-customer", function(){
  // dataLayer.push({
  //   'event': 'login_attempt', 
  //      'eventAction':'attempt',
  //      'eventLabel':'signin',
  //      'eventCategory' : 'login'
  // });
});



$("body").on("click", ".multibuy_master", function () {
  $(this).find(".close_icon").toggleClass("hide");
  $(this).find(".open_icon").toggleClass("hide");
  $(this).find(".multibuy_content").toggleClass("hide");
});

$("body").on("click", ".filter_option", function () {
  $(".filter_option").removeClass("filter_clicked");
  $(this).addClass("filter_clicked");

  var tagText = "_" + $(this).attr("data-text");
  var collectionHandle = $(this).attr("data-collection");
  var collcetionUrlAll = '';
  var collcetionUrlSort = '';
  if(collectionHandle == 'velo-bundle'){
    collcetionUrlAll = '/collections/' + collectionHandle + '/?view=sort-by-bundle';
    collcetionUrlSort = '/collections/' + collectionHandle + '/' + tagText + '/?view=sort-by-bundle';
  }
  else{
    collcetionUrlAll ='/collections/' + collectionHandle + '/?view=sort-by';
    collcetionUrlSort = '/collections/' + collectionHandle + '/' + tagText + '/?view=sort-by'
  }
  if (tagText === '_all') {
    $.ajax({
      type: 'GET',
      url: collcetionUrlAll,
      async: false,
      success: function (data) {
        $(".collection_grid_master").html('');
        $(".collection_grid_master").html(data);
      }
    });
  }
  else {
    $.ajax({
      type: 'GET',
      url: collcetionUrlSort,
      async: false,
      success: function (data) {
        $(".collection_grid_master").html('');
        $(".collection_grid_master").html(data);
      }
    });
  }
});
var productIdFreeCan = '';
$("body").on("click", ".steps_one .steps_questoion", function () {
  $(".steps_one .steps_questoion").removeClass("active");
  $(this).addClass("active");
});

$("body").on("click", ".steps_two .steps_questoion", function () {
  $(".steps_two .steps_questoion").removeClass("active");
  $(this).addClass("active");
});

$("body").on("click", ".steps_three .steps_questoion", function () {
  $(".steps_three .steps_questoion").removeClass("active");
  $(this).addClass("active");
  productIdFreeCan = $(this).attr("data-id");
});

$("body").on("click", ".choose_your_own_users .steps_questoion", function () {
  $(".choose_your_own_users .steps_questoion").removeClass("active");
  $(this).addClass("active");
  productIdFreeCan = $(this).attr("data-id");

});

var freePproductName = '';
var letMeChoose = false;
$("body").on("click", ".back_btn", function () {
  var dataStep = $(this).attr("data-id");
  $(".steps_data").removeClass("show");
  $(".steps_data[data-id='" + dataStep + "']").addClass("show");
});

$("body").on("click", ".next_btn", function () {
  var dataStep = $(this).attr("data-id");
  $(".steps_data").removeClass("show");
  $(".steps_data[data-id=" + dataStep + "]").addClass("show");
  if(dataStep == '2'){
    var selectedVal = $(this).closest(".steps_one_inner").find(".steps_questoion.active").attr("data-user");
    // dataLayer.push({
    //   event: "Free Trial",
    //   question: "1",
    //   quizSelection: "Help Me Find My VELO",
    //   step: "1",
    //   userType: selectedVal
    // })
  }
  if (dataStep == '3') {
    $(".steps_2").addClass("active");
    $(".steps_three .steps_questoion").hide();
    $(".steps_three .steps_questoion").removeClass('active');
    var userType = $(".steps_one .active").attr("data-user");
    var flavourType = $(".steps_two .active").attr("data-user");
    // dataLayer.push({
    //   event: "Free Trial",
    //   flavourSelected: $(".steps_two .active").find(".user_type").text(),
    //   question: "2",
    //   quizSelection: "Help Me Find My VELO",
    //   step: "1"
    // });

    $(".no_product_text").hide();
    if (userType === 'new') {
        $(".steps_three .steps_questoion[data-type=" + flavourType + "][data-user=6]").show();
        $(".steps_three .steps_questoion:visible").eq(0).addClass('active');
        productIdFreeCan = $(".steps_three .steps_questoion:visible").eq(0).attr('data-id');
    }
    else if (userType === 'moderate') {
      // $(".steps_three .steps_questoion[data-type=" + flavourType + "][data-user=6]").show();
      $(".steps_three .steps_questoion[data-type=" + flavourType + "][data-user=10]").show();
      $(".steps_three .steps_questoion:visible").eq(0).addClass('active');
      productIdFreeCan = $(".steps_three .steps_questoion:visible").eq(0).attr('data-id');
    }
    else if (userType === 'regular') {

      $(".steps_three .steps_questoion[data-type=" + flavourType + "][data-user=10]").show();
      // $(".steps_three .steps_questoion[data-type=" + flavourType + "][data-user=14]").show();
      $(".steps_three .steps_questoion:visible").eq(0).addClass('active');
      productIdFreeCan = $(".steps_three .steps_questoion:visible").eq(0).attr('data-id');
    }
    if($(".steps_three .steps_questoion").is(":visible")){

    }
    else{
      $(".no_product_text").show();
    }
  }
  else if (dataStep == '4') {
    $(".steps_3").addClass("active");
    freePproductName = $(".steps_three").find(".steps_questoion.active").find(".user_type").text();
    freePproductName = freePproductName+""+$(".steps_three").find(".steps_questoion.active").find(".variant_title").text();
    if(letMeChoose){
      freePproductName = $(".choose_your_own_users").find(".steps_questoion.active").find(".user_type").text();
      freePproductName = freePproductName+""+$(".choose_your_own_users").find(".steps_questoion.active").find(".variant_title").text();
      
      // dataLayer.push({
      //   "event": "Free Trial",
      //   "quizProduct": freePproductName,
      //   "quizSelection": "Let Me Choose",
      //   "step": "1"
      // })
    }
    else{
      // dataLayer.push({
      //   event: "Free Trial",
      //   question: "3",
      //   quizProduct: freePproductName,
      //   quizSelection: "Help Me Find My VELO",
      //   step: "1"
      // });
    }
  }
});

$("body").on("click", ".choose_own_button", function(){
  $(".steps_data").removeClass('show');
  $(".steps_data.choose_your_own").addClass('show');
  productIdFreeCan = $(".steps_questoion:visible").eq(0).attr('data-id');
});

$("body").on("click", ".button_one .step_one_button", function(){
  $(".free_can_pger_header").hide();
  $(".step_one_master").hide();
  $(".next_steps_master").show();
  // dataLayer.push({
  //   event: "Free Trial",
  //   quizSelection: "Help Me Find My VELO",
  //   step: "1"
  // });
});

$("body").on("click", ".button_two .step_one_button", function(){
  $(".free_can_pger_header").hide();
  $(".step_one_master").hide();
  $(".next_steps.steps_1").addClass("active");
  $(".next_steps.steps_2").addClass("active");
  $(".steps_data").removeClass("show");
  $(".steps_data.choose_your_own").addClass('show');
  $(".next_steps_master").show();
  
  productIdFreeCan = $(".steps_questoion:visible").eq(0).attr('data-id');
  letMeChoose = true;
  // dataLayer.push({
  //   event: "Free Trial",
  //   quizSelection: "Let Me Choose",
  //   step: "1"
  // });
});

var emailValid = false
$(".free_can_email").keyup(function () {
  var email = $("#free_can_email").val();
  if (email != '') {
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!filter.test(email)) {
      //alert('Please provide a valid email address');

      $("#free_can_email").addClass("mb-0");
      $("#error_email").text(email + " is not a valid email");
      $("#error_email").show();
      emailValid = false
      email.focus;
      //return false;
    } else {
      emailValid = true;

      $("#free_can_email").removeClass("mb-0");
      $("#error_email").hide();
    }
  }
});

$("body").on("click", ".last_btn", function(){
  if(emailValid){
    var userEmail = $("#free_can_email").val();
    localStorage.setItem('freeCan_email', userEmail);
    localStorage.setItem('freeCan_avail', 'freeCan_avail');
    if(letMeChoose){
      // dataLayer.push({
      //   "event": "Free Trial",
      //   "quizProduct": freePproductName,
      //   "quizSelection": "Let Me Choose",
      //   "step": "2",
      //   "message": "Verify Your Email"
      // });
    }
    else{
      // dataLayer.push({
      //   "event": "Free Trial",
      //   "quizProduct": freePproductName,
      //   "quizSelection": "Help Me Find My VELO",
      //   "step": "2",
      //   "message": "Verify Your Email"
      // });
    }
    $.ajax({
      type: "GET",
      url: "/cart",
      dataType: "json",
      success: function (data) {
        console.log(data.item_count);
        if(data.item_count === 0){
          freeCanAdd(productIdFreeCan);
        }
        else{
          freeCanPoup();
        }
      },
      error: function (data) {
  
      }
    });
  }
  else{
    $("#error_email").text("Enter valid email");
    $("#error_email").show();
    if(letMeChoose){
      // dataLayer.push({
      //   "event": "Free Trial",
      //   "quizProduct": freePproductName,
      //   "quizSelection": "Let Me Choose",
      //   "step": "2",
      //   "message": "Invalid Email"
      // });
    }
    else{
      // dataLayer.push({
      //   "event": "Free Trial",
      //   "quizProduct": freePproductName,
      //   "quizSelection": "Help Me Find My VELO",
      //   "step": "2",
      //   "message": "Invalid Email"
      // });
    }
  }
});

function freeCanAdd(productId){
  localStorage.setItem("free_can_id", productIdFreeCan);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: productId,
      quantity: 1,
      properties: {
        "_freeCan": '_freeCan'
      }
    },
    success: function (data) {
      localStorage.setItem('free_can_note', 'Free Can');
      if (userId != ''){
        window.location.href = '/cart';
      }
      else{
        window.location.href = '/account/register';
      }
    },
    error: function (data) {

    }
  });
}

function freeCanPoup(){
  $(".overlay").addClass("overlay-opens-password");
  $("body").addClass("drawer-opens-password");
  $(".clear_cart_popup").addClass("view-address-model");
}

function CartFullPoup(){
  $(".overlay").addClass("overlay-opens-password");
  $("body").addClass("drawer-opens-password");
  $(".qty_cart_popup").addClass("view-address-model view-cart-model");
}


$("body").on("click", ".clear_cart_button", function(e){
  e.preventDefault();
  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    data: '',
    success: function (data) {
      freeCanAdd(productIdFreeCan);
    },
    error: function (data) {

    }
  });
});

$("body").on("click", ".show_more_section_2", function(){
  $(".abt_section_2_right").slideToggle();
  $(this).hide();
});

$("body").on("click", ".show_less_section_2", function(){
  $(".abt_section_2_right").slideToggle();
  $(".show_more_section_2").show();
});

$("body").on("click", ".show_more", function(){
  $(".abt_section_5_left").addClass("open");
  $(this).hide();
  $(".show_less").show();
});

$("body").on("click", ".show_less", function(){
  $(".abt_section_5_left").removeClass("open");
  $(this).hide();
  $(".show_more").show();
});

$('body').on('click', ".slide_item", function(){
  $(".left_inner_img").find("img").attr("src", $(this).data("image"));
  $(".left_inner_text").find("h3").find("span").text($(this).find(".season_ep").text());
  $(".left_inner_text").find("a").attr("href", $(this).data("link"));
});

$("body").on("click", ".season_count", function(){
  var dataId = $(this).data("id");
  $(".season_count").removeClass("active");
  $(this).addClass("active");
  $(".season_artis_list").removeClass("show-season");
  $(".season_artis_list[data-id='"+dataId+"']").addClass("show-season");
  $("#season_view_all").attr("href", $(".season_artis_list[data-id='"+dataId+"']").data("link"));
});

$("body").on("click", "#season_view_all", function(e){
  e.preventDefault();
  $(".sound_section_3").toggleClass("show_all");
  $("#season_view_all").hide();
})

$("body").on("click", ".cart__remove a", function(){
  var parentDiv = $(this).closest(".cart__item");
  var productTitle = $(parentDiv).attr("data-title");
  var price = $(parentDiv).attr("data-price");
  var variant = $(parentDiv).find(".drawer_variant").text();
  var sku = $(parentDiv).attr("data-sku");
  // dataLayer.push({
  //   'event': 'removeFromCart',
  //   'ecommerce': {
  //     'remove': {
  //       'products': [
  //         {
  //           'name': productTitle,
  //           'id': sku,
  //           'price': price,
  //           'brand': 'VELO PK',
  //           'strength': variant,
  //           'quantity': 0,
  //           'format': 'Can',
  //           'dimension': variant,
  //         }
  //       ]
  //     }
  //   }
  // });
});

$("body").on("click", ".js-qty__adjust_cart", function () {
  var inputVal = parseInt($(this).closest(".cart_update_button_master").find("input").val());
  var productId = $(this).closest(".cart_update_button_master").find("input").attr("data-id");
  var parentDiv = $(this).closest(".cart__item");
  var productTitle = $(parentDiv).attr("data-title");
  var price = $(parentDiv).attr("data-price");
  var collection = $(parentDiv).attr("data-collection");
  var variant = $(parentDiv).find(".drawer_variant").text();
  var sku = $(parentDiv).attr("data-sku");
  if ($(this).hasClass("js-qty__adjust--minus")) {
      inputVal = inputVal;
      // dataLayer.push({
      //   'event': 'removeFromCart',
      //   'ecommerce': {
      //     'remove': {
      //       'products': [
      //         {
      //           'name': productTitle,
      //           'id': sku,
      //           'price': price,
      //           'brand': 'VELO PK',
      //           'strength': variant,
      //           'quantity': inputVal,
      //           'format': 'Can',
      //           'dimension': variant,
      //         }
      //       ]
      //     }
      //   }
      // });
    }
  else {
    // dataLayer.push({
    //   'event': 'add_to_cart',
    //   'ecommerce': {
    //     'items': [{
    //       'item_name': productTitle, // Name or ID is required. 
    //       'item_id': productId,
    //       'price': price,
    //       'item_brand': 'VELO PK',
    //       'item_category': collection,
    //       'item_category_2': '',
    //       'item_category_3': '',
    //       'item_category_4': '',
    //       'item_variant': variant,
    //       'item_list_name': '',
    //       'item_list_id': '',
    //       'index': 1,
    //       'quantity': inputVal
    //     }]
    //   }
    // });
  }
});

$(window).scroll(function (event) {
  if($(window).scrollTop() > 65){
    $("#shopify-section-header-bottom").addClass("header_bottom_fixed");
  }
  else{
    $("#shopify-section-header-bottom").removeClass("header_bottom_fixed");
  }
});

function vssPage(url){
  $.ajax({
    type: 'GET',
    url: url,
    async: false,
    success: function (data) {
      console.log(data);
      $(".sound_station_master").html('');
      $(".sound_station_master").html(data);
    }
  });
}

$("body").on("click", ".bottom_left a", function(e){
  e.preventDefault();
  var dataHref = $(this).data("href");
  vssPage(dataHref)

});

function removeCart(){
  $.ajax({
    type: "GET",
    url: "/cart",
    dataType: "json",
    success: function (data) {
      if(data.item_count >= 10){
        freeCanPoup();
        return false;
      }
      // else{
      //   freeCanPoup();
      // }
    },
    error: function (data) {

    }
  });
}

function cartQuantity(itemCount){
  $.ajax({
    type: "GET",
    url: "/cart",
    dataType: "json",
    success: function (data) {
      itemCount(data.item_count);
    },
    error: function (data) {
      
    }
  });
}
$("body").on("click", ".faq_ques", function(){
  $(this).toggleClass("open");
  $(this).toggleClass("close");
  $(this).closest(".pdp_faqs").find(".faq_answer").slideToggle();
});
$("body").on("click", ".popup_close_btn", function(){
  $(".retail_popup_master").removeClass("open");
});
$("body").on("click", ".find_popup", function(){
  $(".retail_popup_master").addClass("open");
  dataLayer.push({ 'event' : 'shop_button_click', });
});

$("body").on("click", ".retailers_link a", function(){
  // $(".retail_popup_master").addClass("open");
  dataLayer.push({ 'event' : 'shop_button_click', });
});

$("body").on("click", ".find_popup_product, .redirect_btn", function(){
  window.open($(this).attr("data-link"));
});

$("body").on("click", ".hero_image_text_v2_text a", function (e) {
  e.preventDefault();

  var target = this.hash; // Extracts the hash (e.g., #section2)
  if (target) {
    if ($(target).length) {
        $("html, body").animate({
            scrollTop: $(target).offset().top - 40
        }, 800);
    }
  }
});
$("body").on("click", ".grid-item__varaint-grid", function(){
  window.location.href= $(this).attr("data-link");
});